import { useCallback, useEffect, useState } from 'react';

function read(key: string, fallback: boolean): boolean {
  if (typeof window === 'undefined') return fallback;
  try {
    const stored = window.localStorage.getItem(key);
    return stored == null ? fallback : stored === '1';
  } catch {
    return fallback;
  }
}

export function useCollapsiblePref(
  key: string,
  defaultCollapsed = false,
): [boolean, (next?: boolean) => void] {
  const [collapsed, setCollapsed] = useState<boolean>(() => read(key, defaultCollapsed));

  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key === key) setCollapsed(read(key, defaultCollapsed));
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, [key, defaultCollapsed]);

  const toggle = useCallback(
    (next?: boolean) => {
      setCollapsed((prev) => {
        const value = next ?? !prev;
        try {
          window.localStorage.setItem(key, value ? '1' : '0');
        } catch {
          /* ignore */
        }
        return value;
      });
    },
    [key],
  );

  return [collapsed, toggle];
}

export const NAV_COLLAPSED_KEY = 'meridian.nav.collapsed';
export const ADMIN_NAV_COLLAPSED_KEY = 'meridian.adminnav.collapsed';
